export default {
    'confirmed': 'Potwierdzona',
    'cancelled': 'Anulowana',
    'settled': 'Rozliczona',
    'finished': 'Zakończona',
    'rejected': 'Odrzucona',
    'waiting_for_business_approval': 'Oczekuje na potwierdzenie biznesu'
}